import $ from "jquery";


$(window).on('scroll', function (event) {
  let s = $(this).scrollTop();
  let w = $(this).outerWidth();
  let h = $('.header').outerHeight();
  let h_b = $('.header__parallax-fog').outerHeight();
  let p = s / h * 100;
  let p_b = s / h_b * 100;
  let o = 1 - 1 / 100 * p_b;

  let z_1 = 1 + (w / 5000 * p_b);
  let z_2 = (100 - p_b) / 100;

  if (z_1 <= 5) {
    $('.header__parallax-fog').css('transform', 'scale(' + z_1 + ')');
    $('.header__parallax-fog').css('opacity', z_2);
    $('.header__parallax-fog').css('visibility', 'visible');
  }
  else {
    $('.header__parallax-fog').css('visibility', 'hidden');
  }

});
